import Swal from "sweetalert2";

const alertService = {
  success,
  error,
  warning,
  info,
  confirm,
};

// Success Alert
function success(title, message, confirmButtonText = "OK") {
  Swal.fire({
    title,
    text: message,
    icon: "success",
    confirmButtonText,
  });
}

// Error Alert
function error(title, message, confirmButtonText = "OK") {
  Swal.fire({
    title,
    text: message,
    icon: "error",
    confirmButtonText,
  });
}

// Warning Alert
function warning(title, message, confirmButtonText = "OK") {
  Swal.fire({
    title,
    text: message,
    icon: "warning",
    confirmButtonText,
  });
}

// Info Alert
function info(title, message, confirmButtonText = "OK") {
  Swal.fire({
    title,
    text: message,
    icon: "info",
    confirmButtonText,
  });
}

// Confirm Alert
async function confirm(title = "", message, confirmButtonText = "Yes", cancelButtonText = "No") {
  const userResult = await Swal.fire({
    title,
    text: message,
    icon: "question",
    showCancelButton: true,
    confirmButtonText,
    cancelButtonText,
  }).then((result) => {
    if (result.isConfirmed) return true;
    else if (result.isDenied) return false;
    else if (result.isDismissed) return false;
  });
  return userResult;
}

export default alertService;
